<svg fill="none" height="93" viewBox="0 0 100 93" width="100" xmlns="http://www.w3.org/2000/svg"><path d="m33 52-32.5 41h99l-24.5-33-17 22z" fill="#fff" opacity=".2"/><circle cx="79" cy="13" fill="#c4c4c4" opacity=".1" r="13"/></svg>
